import { Button, Result } from 'antd'
import React from 'react';
import { createBrowserHistory } from "history"

const history = createBrowserHistory();

const NotFound = () => {

  const onClick = () => {
    history.push('/')
    history.go()
  }

  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={<Button type="primary" onClick={onClick}>Back Home</Button>}
      style={{ height: '100vh' }}
    />
  )
}


export default NotFound